import { DataVariableType } from '@empathy/global/data';

import { MatchType } from './match-type.enum';
import { QueryOperator } from './query-operator.enum';

export class Query {
  applicablePanelId: string;
  defineParticipantsInd: boolean;
  matchType: MatchType;
  queryRows: QueryRow[];
}

export class QueryRow {
  id: string;
  dataVariableKeyName: string;
  typeId: DataVariableType;
  queryOperator: QueryOperator;
  queryValue: string | string[];
  hasSubgroup: boolean;
  subgroup: Query;
}
